import React from "react";
import { useTranslation } from "react-i18next";

import Checkbox from "./Checkbox";

interface IsFavoriteCheckboxProps {
  isFavorite: boolean;
  onChange: (status: boolean) => void;
}

const IsFavoriteCheckbox: React.FC<IsFavoriteCheckboxProps> = ({
  isFavorite,
  onChange,
}) => {
  const { t } = useTranslation();
  return (
    <div className="w-full h-[46px] min-h-[46px] flex items-center px-3 border border-[#9B9B9B] rounded-lg bg-white">
      <Checkbox
        name={"all"}
        label={t("_published_picture._sensei_fusen")}
        labelClassName="text-sm break-normal whitespace-nowrap"
        isChecked={isFavorite}
        onChange={onChange}
      />
    </div>
  );
};

export default IsFavoriteCheckbox;
